<template>
	<div class="pt-3 px-5 pb-5 page-fill">
        <div class="mb-2 flex-shrink-0">
            <breadCrumbs :routesArray="routesArray"></breadCrumbs>
    
	    </div>
		<div class="items-center justify-between flex flex-shrink-0">
			<div class="title flex items-center">
				<h1>Compliance Review</h1>
			</div>
			<div class="flex items-center gap-3">
                <!-- <div class="flex parent-toggle-border border rounded-sm border-lightgrey bg-white">
                <button :class="{ 'active-tab': activeButton === 'myControls', 'inactive-tab': activeButton !== 'myControls' }" class="flex items-center font-semibold justify-center rounded p-px leading-3 cursor-pointer w-28 h-8 text-xs" @click="showMyControls">
                    My Tasks
                </button>
                <button :class="{ 'active-tab': activeButton === 'allControls', 'inactive-tab': activeButton !== 'allControls' }" class="flex items-center font-semibold justify-center rounded p-px leading-3 cursor-pointer w-28 h-8 text-xs" @click="showAllControls">
                    All Tasks
                </button>
            </div> -->
            <!-- <button class="btnprimary hidden items-center" @click="showAddControlPopup()">
             <img src="@/assets/plusIcon.svg" class="h-3 mr-2" />
                Add
            </button> -->
            <button class="flex" @click="filterOpen" :class="'filterButton'">
				<!-- <img  v-if="sortedData.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/> -->
				<img  src="@/assets/filter.svg" class="filterIcon" />
                Filters
			</button>
			</div>
		</div>
		<div class="mt-5 flex-shrink-0">
			<p class="headerText">
                Manage evidence collection tasks related to compliance reviews. Assign, track, and upload supporting documents to demonstrate control effectiveness and maintain audit readiness across your organization.
			</p>
		</div>
		<div class="flex flex-col flex-1 min-h-0 overflow-hidden">
        <div class="mt-5 table-section min-h-0 cr-table-hug">
			<div class="tableCornerRadius bg-white table-card-shell mapping-inline-table">
			<div class="table-container table-container-fit cr-table-x-scroll" :style="{ '--cr-table-width': crTableWidth }">
				<div class="table-header-wrap" ref="headerWrap">
				<table class="table-fit-card table-header-table" :style="tableResizeStyle">
					<colgroup>
						<col v-for="column in columnNames" :key="'h-'+column" :style="columnStyle(column)" />
					</colgroup>
					<thead>
						<tr class="table-header-row">
						<th scope="col" v-for="column in columnNames" :key="column" class="bg-white th1 cursor-pointer capitalize resizable-th" :class="getColumnHeadWidth(column)" :style="columnStyle(column)" @click="onHeaderClick(column)">
							<div class="flex" :class="column=='statusCode' || column == 'dueDate'? 'justify-center':''">
                                <div v-if="column == 'taskId'">
                                    <div>{{ 'ID' }}</div>
                                </div>
                                <div v-else-if="column == 'clientUniqueId'" >
                                    <div>{{ 'CID' }}</div>
                                </div>
                                <div v-else-if="column == 'controlTitle'">
                                    <div>{{ 'Title' }}</div>
                                </div>
                                <div v-else-if="column == 'departments'">
                                    <div>{{ 'Team' }}</div>
                                </div>
                                <div v-else-if="column == 'entity'">
                                    <div>{{ 'Location' }}</div>
                                </div>
                                 <div v-else-if="column == 'tier'">
                                    <div>{{ 'Tier' }}</div>
                                </div>
                                 <div v-else-if="column == 'tierTitle'">
                                    <div>{{ 'Scope' }}</div>
                                </div>
                                <div v-else-if="column == 'dueDate'">
                                    <div>{{ 'Due Date' }}</div>
                                </div>
                                 <div v-else-if="column == 'statusCode'" class="flex items-center">
                                    <div>{{ 'Status' }}</div>
                                </div>
								<div class="sort cursor-pointer" :class="className == column ? classSort : 'opacity-50'"></div>
							</div>
							<span class="column-resize-handle" @mousedown.stop.prevent="startColumnResize($event, column)"></span>
						</th>
						</tr>
						<tr v-if="showFilters" class="table-filter-row">
							<td v-for="name in columnNames" class="bg-white" :key="name" :style="columnStyle(name)">
                               <div v-if="name == 'statusCode'" class="flex justify-center items-center">
                                    <select :class="filterDummy[name]==null? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filterDummy[name]">
                                    <option :value="filterDummy.name" selected hidden disabled>Select</option>
                                    <option class="optionColors" v-for="option in statuses" :key="option.id" :value="option.id">{{ option.label }}</option>
                                </select>
                                </div>
                                <div v-else-if="name == 'tier'" class="flex justify-center items-center">
                                    <select :class="filterDummy[name]==null? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filterDummy[name]">
                                    <option :value="filterDummy.name" selected hidden disabled>Select</option>
                                    <option class="optionColors" v-for="option in tierLevel" :key="option.id" :value="option.id">{{ option.value }}</option>
                                </select>
                                </div>
                                
                                <input v-else-if="name == 'clientuniqueId'" type="text" class="inputboxstylingForControlID" placeholder="Search" v-model="filterDummy[name]" />
                                <input v-else-if="name=='dueDate'" class="flex">
								<input v-else type="text" class="searchForInputBoxStyling" placeholder="Search" v-model="filterDummy[name]" />
							</td>
						</tr>
					</thead>
				</table>
				</div>
				<div class="table-body-scroll" ref="bodyScroll" @scroll="syncTableXScroll">
				<table class="table-fit-card" :style="tableResizeStyle">
					<colgroup>
						<col v-for="column in columnNames" :key="'b-'+column" :style="columnStyle(column)" />
					</colgroup>
                    <tbody v-if="dataLoading == true">
                        <tr class="cursor-pointer empty rowHeight">
                            <td class="relative h-5" :colspan="8">
                                <div class="flex items-center justify-center w-full h-16 skeleton">
                                    <dots-loader/>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody class="empty" v-else-if="sortedData.length == 0">
                        <tr class="cursor-pointer rowHeight">
                            <td class="relative h-10" :colspan="columnNames.length">
                                <div class="flex justify-center items-center"><p class="text-xs font-normal">No Records Found</p></div>
                            </td>
                        </tr>
                    </tbody>
					<tbody v-else class="nonEmptyTable">
						<tr  v-for="(row, index) in sortedData" :key="row._id || index" class="rowHeight hoverEffectForCompleteRow" @click="goToControlTaskEdit(row)">                            
                            <td v-for="presentColumn in columnNames" :key="presentColumn" class="cursor-pointer relative" :class="getColumnHeadWidth(presentColumn)" :style="columnStyle(presentColumn)">
                                <div v-if="presentColumn == 'statusCode'" class="flex justify-center items-center">
                                    <div class="flex items-center justify-center rounded h-5 w-32 ml-1.5" :class="colorComplianceBg(row.statusCode)">
                                        <div :class="colorComplianceText(row.statusCode)">
                                            {{
                                                statuses.find((l) => {
                                                    return l.id == row[presentColumn];
                                                })?.label|| 'N/A'
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="presentColumn=='tier'">
                                    <div>
                                            {{
                                                tierLevel.find((l) => {
                                                    return l.id == row[presentColumn];
                                                })?.value|| 'N/A'
                                            }}
                                        </div>
                                </div>
                                 <div v-else-if="presentColumn=='dueDate'" class="flex justify-center items-center w-24 rounded h-5" :class="shouldStyleDueDate(row) ? colorForDueDate(row[presentColumn]) : ''">
                                    {{ row[presentColumn] }} 
                                </div>
                                <div v-else>{{ row[presentColumn] }}</div>
                            </td>
                        </tr>
					</tbody>
				</table>
				</div>
                <div v-if="toolTipActive">
                    <tool-tip :tipText="toolTipText"></tool-tip>
                </div>
            </div>
				<div class="flex-shrink-0">
				<pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedData"></pagination>
				</div>
            </div>
		</div>
		</div>
	</div>
</template>
<style scoped>
.cr-table-x-scroll .table-header-wrap,
.cr-table-x-scroll .table-body-scroll {
	scrollbar-gutter: stable;
	scrollbar-width: thin;
}
.cr-table-x-scroll .table-header-wrap {
	overflow-x: hidden;
	overflow-y: scroll;
}
.cr-table-x-scroll .table-body-scroll {
	overflow-x: auto;
	overflow-y: scroll;
}
.cr-table-x-scroll .table-header-wrap::-webkit-scrollbar,
.cr-table-x-scroll .table-body-scroll::-webkit-scrollbar {
	width: 6px !important;
	height: 8px !important;
}
.cr-table-x-scroll .table-header-wrap::-webkit-scrollbar-thumb {
	background: transparent !important;
}
.cr-table-x-scroll .table-body-scroll::-webkit-scrollbar-thumb {
	background: #c4c4c4 !important;
	border-radius: 4px !important;
}
.cr-table-x-scroll .table-fit-card {
	table-layout: fixed !important;
	width: var(--cr-table-width, 100%) !important;
	min-width: var(--cr-table-width, 100%) !important;
	max-width: none !important;
}
.cr-table-x-scroll .table-fit-card th,
.cr-table-x-scroll .table-fit-card td,
.cr-table-x-scroll .table-fit-card col {
	box-sizing: border-box;
}
.cr-table-hug {
	flex: 1 1 0%;
	max-height: 100%;
	min-height: 0;
	overflow: hidden;
}
.cr-table-hug .table-card-shell,
.cr-table-hug .mapping-inline-table,
.cr-table-hug .table-container-fit,
.cr-table-hug .cr-table-x-scroll {
	flex: 1 1 0%;
	max-height: 100%;
	min-height: 0;
	overflow: hidden;
}
.cr-table-hug .table-body-scroll {
	flex: 1 1 0%;
	max-height: 100%;
	min-height: 0;
	overflow-y: auto;
}
/* table {
  table-layout: fixed;
  width: 100%;
} */
.table-ellipsisForValue {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
 .table-container {
  width: 100%;
  overflow-x: auto;
}
table {
  table-layout: fixed;
}
.popup-business {
    overflow-y: scroll;
}
::-webkit-scrollbar {
    width: 0px;
}
.optionColors{
   color : #4D4D4D !important;
}
.table-ellipsis {
  display:-webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.nonEmptyTable:last-child  {
	border-bottom: 1px solid #e9e9e9;
}
.rowHeight {
	height: 60px;
}
.numberBorder{
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
}
.numberNavy{
    border-left: 1px solid #152A43;
    border-left-width: 2px;
}
.active-tab {
    background-color: #1976d2;
    color: white;
}
.active-tab, .inactive-tab {
    transition: background-color 0.4s ease, color 0.4s ease;
}
.inactive-tab {
    color: black;
    fill: #1976d2 !important;
}
.widthFixing{
    width : 135px;
}
.pendingEvidence{
    background-color: #8600f040;
}

select {
  background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.65166 4.18411C1.39599 4.28576 1.20193 4.46133 1.07564 4.69852C0.980151 4.88334 0.97399 5.35463 1.06332 5.54561C1.14957 5.72734 8.24662 12.8275 8.44068 12.926C8.56081 12.9876 8.62857 13 8.875 13C9.12143 13 9.18919 12.9876 9.30932 12.926C9.50338 12.8275 16.6004 5.72734 16.6867 5.54561C16.776 5.35463 16.7698 4.88334 16.6744 4.69852C16.5789 4.5137 16.3879 4.32272 16.2123 4.23339L16.0675 4.15946L8.9058 4.1533C3.46597 4.15022 1.72251 4.15638 1.65166 4.18411Z' fill='%234D4D4D'/%3E%3C/svg%3E");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: 12px 12px;
  background-position: right 6px center !important; /* Change the px value here to change the distance */
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}
.bgDisabledGrey{
	background-color: rgba(164, 164, 164, 0.2);
}
.bgError{
	background-color: rgba(255, 0, 0, 0.2);
}
.bgdarkred{
	background-color: rgba(192, 0, 0, 0.2);
}
.bgYellow{
	background-color: rgba(255, 153, 0, 0.2);
}
.bgLightGreen{
	background-color: rgba(0, 176, 80, 0.2);
}
.bgGreen{
	background-color: rgba(146, 208, 80, 0.2);
}
.bgElectricGreen{
	background-color: rgba(134, 0, 240, 0.2);
}
.bgForReview{
	background-color: rgba(8, 91, 150, 0.2);
}
.bgPrimary{
	background-color: rgba(21, 42, 67, 0.2);
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { required } from '@vuelidate/validators';
import tableData from '@/components/tableData.vue';
import { mapGetters } from 'vuex';
import { emitter, toast } from '@/main';
import { groupBy } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import pagination from '@/components/pagination.vue';
import popup from '@/components/popup.vue';
import breadCrumbs from '@/components/breadCrumb.vue';
import toolTip from '@/components/toolTip.vue';
import dotsLoader from '@/components/dotsLoader.vue';
import moment from 'moment';
import { REVIEW_BACKLOG_STATUSES, CLOSED_TASK_STATUSES, isDateInPeriod, isOverdueDate } from '@/utils/dashboardKpi';
import { columnResizeMixin } from '@/mixins/columnResizeMixin';

export default defineComponent({
	mixins: [columnResizeMixin],
	data(): any {
		return {
			showFilters: false,
            visibility: false,
            allFrameWorkControls:[],
            filters: {},
            orgFrameWorks:[],
            presentComplianceFrameWorks:[],
            tableRow:[],
            allTableRows:[],
            mainHeaders:[],
            filterDummy: {},
			classSort: '',
			className: '',
			dummyList:[],
            statuses:[],
            tierLevel:[
                {
                    id:10107,
                    value:'Activity'
                },
                {
                    id:10108,
                    value:'System'
                },
                {
                    id:10109,
                    value:'Project'
                }
            ],
			pageType: '',

			currentSort: 'name',
			currentSortDir: 'asc',

			currentPage: '',
			pageSize:'',
			dynamicPagination: '',
            teamObject:[],
            allEntities: [],
            teamsData:[],
            locationObject:[],
            pop: false,
			styling: { left: '', bottom: '' },
			tipText: '',
			tipColumn: '',
			tipIndex: '',
            activeButton:'',
            addControlPopup:false,
            controlAddObject:{
                controlNumber:'',
                controlTitle:'',
                team:'',
                entity:'',
            },
            viewControlNumberPopup:false,
            frameWorkControlNumberObject:{},
            complianceStatusCodes: [
				{
					id: 10401,
					value: 'Not Started'
				},
				{
					id: 10415,
					value: 'In Review'
				},
                // {
				// 	id: 10416,
				// 	value: 'Evidence Uploaded'
				// },
                {
					id: 10403,
					value: 'Completed'
				},
                {
					id: 10417,
					value: 'Not Applicable'
				},
                {
					id: 10418,
					value: 'Terminated'
				}
			],
            startAuditTitle:[],
            routesArray: [],
            presentCompliance:{},
            internalControlsDetailsArray:[],
            mainAuditControls:[],
            tasksForCompliance:[],
            toolTipActive:false,
			toolTipText:'',
            columnNames:['taskId','clientUniqueId','controlTitle','tier','tierTitle','departments','entity','dueDate','statusCode'],
            dataLoading:true,
            complaincereviewTasks:[],
            onDetailsModalClosed: null as null | (() => void),
		};

	},
	components: {
        pagination,
        popup,
        toolTip,
        breadCrumbs,
        tableData,
        dotsLoader
	},
	computed: {
		...mapGetters({ userInfo: 'userInfo' }),
		crTableWidth(): string {
			const names = Array.from(this.columnNames || []) as string[];
			const widths = this.columnWidths || {};
			const measured = names.filter((name: string) => Number(widths[name]) > 0);
			if (!names.length || measured.length !== names.length) {
				return '100%';
			}
			const total = names.reduce((sum: number, name: string) => sum + Number(widths[name]), 0);
			return total + 'px';
		},
        sortedData: function (): any {            
			return [...this.tableRow]
				.filter((row: any, index: any) => {
                    for (const key in this.filterDummy) {
                        const inputValue = this.filterDummy[key];
 
                        if (inputValue !== '' || row[key]) {
 
                            if (Number(inputValue) && isNaN(row[key])) {
                                if (!String(row[key]).includes(inputValue)) {
                                    return false;
                                }
                            } else {
                                if (row[key] == null) {
                                    return false;
                                }
                                if (!row[key].toString().toLowerCase().includes(inputValue.toString().toLowerCase())) {
                                    return false;
                                }
                            }
                        }
                    }
                    return true;
                })
				.sort((a, b) => {
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
                    if(this.currentSort=='taskId'){
                        const aVal = (a[this.currentSort] ?? '').toString();
                        const bVal = (b[this.currentSort] ?? '').toString();
                        const aNumMatch = aVal.match(/\d+$/);
                        const bNumMatch = bVal.match(/\d+$/);
                        if (aNumMatch && bNumMatch) {
                            const aNum = parseInt(aNumMatch[0], 10);
                            const bNum = parseInt(bNumMatch[0], 10);
                            if (aNum < bNum) return -1 * modifier;
                            if (aNum > bNum) return 1 * modifier;
                            return 0;
                        }
                        if (aVal < bVal) return -1 * modifier;
                        if (aVal > bVal) return 1 * modifier;
                    }
                    else{
                        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    }
					return 0;
				})
                .filter((row, index) => {
					this.dynamicPagination = index + 1;
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
		},
	},
	async created() {
        this.dataLoading = true;
        await this.getCrStatuses()
        await this.getallEntities();
        await this.getAllTeams();
        await this.getTableData();
        this.showMyControls();
        this.dataLoading = false;        
		this.$nextTick(() => this.snapshotColumnWidths());
		this.onDetailsModalClosed = (payload?: any) => { this.refreshAfterDetailsModal(payload); };
		emitter.off('detailsModalClosed', this.onDetailsModalClosed);
		emitter.on('detailsModalClosed', this.onDetailsModalClosed);
    },
	mounted() {
		this.$nextTick(() => this.snapshotColumnWidths());
    },
	beforeUnmount() {
		if (this.onDetailsModalClosed) {
			emitter.off('detailsModalClosed', this.onDetailsModalClosed);
		}
	},
	methods: {
		syncTableXScroll() {
			const header = this.$refs.headerWrap as HTMLElement | undefined;
			const body = this.$refs.bodyScroll as HTMLElement | undefined;
			if (!header || !body) {
				return;
			}
			header.scrollLeft = body.scrollLeft;
		},
		async refreshAfterDetailsModal(payload?: any) {
			if (payload?.view && payload.view !== 'crTask') {
				return;
			}
			// Drop status filter so an updated status (e.g. In Review) remains visible in the table
			if (this.filterDummy && Object.prototype.hasOwnProperty.call(this.filterDummy, 'statusCode')) {
				const nextFilters = { ...this.filterDummy };
				delete nextFilters.statusCode;
				this.filterDummy = nextFilters;
			}
			await this.getTableData();
			if (this.activeButton === 'allControls') {
				this.showAllControls();
			} else {
				this.showMyControls();
			}
			this.$nextTick(() => this.snapshotColumnWidths());
		},
         getBorder(){
            return `numberBorder numberNavy`
        },
        shouldStyleDueDate(row:any) {
            const status = row.taskStatus ?? row.statusCode;
            return status != 10403 && status != 10418;
        },
        sort: function (s: any) {
            this.className = s;
            if (s === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            }
            this.currentSort = s;
            this.classSort = this.currentSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
        },
        isPastDue(date:any) {            
            if (!date) return false;
            const [day, month, year] = date.split('-');
            const due = new Date(Number(year), Number(month) - 1, Number(day));
            const today = new Date();
            due.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);                        
            return due < today;
        },
        getColumnHeadWidth(column :any){
            if(column=='taskId' || column=='clientUniqueId'||column=='tier'){
                return 'w-24'
            }
            // else if(){
            //     return 'w-56'
            // }
            // else if(){
            //     return 'w-28'
            // }
            else if(column=='controlTitle') {
                return 'w-48'
            }
            else if(column=='departments'|| column=='dueDate') {
                return 'w-32'
            }else if(column=='entity') {
                return 'w-32'
            }else if(column=='entity'||column=='tierTitle') {
                return 'w-36'
            }
            else if(column=='statusCode') {
                return 'w-36'
            }

        },
        showMyControls(){
            this.activeButton = 'myControls'
        },
        showAllControls(){
            this.activeButton = 'allControls'
        },
        paginationUpdations(currentPage: any, pageSize: any) {
			this.currentPage = currentPage;
			this.pageSize = pageSize;
		},
        getResizeColumnNames() {
            return this.columnNames || [];
		},
        colorComplianceBg(status: any) {
			if (status == 10401) {
				return ['bgDisabledGrey border-solid border border-disabledgrey'];
			} else if (status == 10402 || status == 10415 || status == 10421) {
				return ['bgYellow border-solid border border-yellow'];
			} else if (status == 10403) {
				return ['bgLightGreen border-solid border border-lightgreen'];
			} else if (status == 10414) {
				return ['bgElectricGreen border-solid border border-electricGreen'];
			} else if (status == 10416) {
				return ['bgPrimary border-solid border border-primary'];
			}else if (status == 10417) {
				return ['bgdarkred border-solid border border-darkred'];
			}else if (status == 10418) {
				return ['bgError border-solid border border-error'];
			}
		},
        colorForDueDate(date: any) {
            if (!date) return false;
            const [day, month, year] = date.split('-');
            const due = new Date(Number(year), Number(month) - 1, Number(day));
            const today = new Date();
            due.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);
            if(due<today){
                return ["bgdarkred border-solid border mx-2 text-darkred font-semibold flex justify-center items-center"]
			}
			
		},
        colorComplianceText(status: any) {
			if (status == 10401) {
				return ['font-semibold text-disabledgrey'];
			} else if (status == 10402 || status == 10415 || status==10421) {
				return ['font-semibold text-yellow'];
			} else if (status == 10403) {
				return ['font-semibold text-lightgreen'];
			} else if(status == 10414){
				return ['font-semibold mx-2 text-electricGreen']
			} else if(status == 10416){
				return ['font-semibold mx-2 text-primary']
			}else if(status == 10417){
				return ['font-semibold mx-2 text-darkred']
			}else if(status == 10418){
				return ['font-semibold mx-2 text-error']
			}
		},
        async getTableData(){
             const rows: any[] = [];
             await this.$http.get(`${process.env.VUE_APP_MONITOR_API}/api/org/tasks/getall`).then((result: any) => {
                   this.complaincereviewTasks = result.data;
                });
                this.complaincereviewTasks.map((task:any)=>{
                    if(task && task.actionType==20501){
                        let tier:any;
                    let department = this.teamObject.find((team:any)=>team.value==task.departments);                    
                    let entity = this.locationObject.find((e:any)=>e.value==task.entity);
                    if(Object.keys(task).includes('categoryType') && task.categoryType==10107){
                        tier=10107
                    }
                    else if(Object.keys(task).includes('categoryType') && task.categoryType==10108){
                        tier=10108
                    }
                    else if(Object.keys(task).includes('categoryType') && task.categoryType==10109){
                        tier=10109
                    }
                    if(task.controlTitle==null && task.mainTaskName!=undefined){
                        task.controlTitle = task.mainTaskName
                    }
                    let obj={
                        _id:task._id,
                        taskId:task.taskId,
                        linkedControlID: task.linkedControlID,
                        clientUniqueId:task.clientUniqueId!=undefined?task.clientUniqueId:'N/A',
                        controlTitle:task.controlTitle!=undefined? task.controlTitle:task.riskTitle,
                        departments:department && department!=undefined?department.label:'N/A',
                        entity:entity && entity!=undefined?entity.label:'N/A',
                        statusCode:task.statusCode,
                        completedAt: task.completedAt,
                        createdAt: task.createdAt,
                        endDate: task.endDate,
                        dueDateRaw: task.dueDate || task.endDate,
                        tier:tier && tier!=undefined?tier:'N/A',
                        tierTitle:task.tierTitle && task.tierTitle!=undefined?task.tierTitle:'N/A',
                        dueDate:task.dueDate!=undefined?moment(task.dueDate).format('DD-MM-YYYY'):'N/A'
                    }
                    if(obj.controlTitle==undefined) {
                        obj.controlTitle='N/A'
                    }
                    rows.push(obj);
                    }  
                })
                this.tableRow = rows;
                this.allTableRows = [...rows];
                this.applyDashboardKpiFilter();
                

            // this.tableRow=[...this.sortedData]
            // console.log('asdf',this.tableRow);
        },
        applyDashboardKpiFilter() {
            const kpi = String(this.$route.query.kpi || '');
            if (!kpi) {
                this.tableRow = [...this.allTableRows];
                return;
            }
            this.tableRow = this.allTableRows.filter((row: any) => {
                const status = Number(row.statusCode);
                if (kpi === 'reviewsPending') {
                    return REVIEW_BACKLOG_STATUSES.includes(status);
                }
                if (kpi === 'reviewOverdue') {
                    return !CLOSED_TASK_STATUSES.includes(status) && isOverdueDate(row.dueDateRaw || row.endDate || row.dueDate);
                }
                if (kpi === 'controlPassRate') {
                    return status === 10403 && isDateInPeriod(row.completedAt || row.createdAt, this.$route.query);
                }
                return true;
            });
        },
        async getCrStatuses(){
			let appId='10001';
			let entityId='10118';
			await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`).then((result: any) => {				
                this.statuses = result.data.statuses
			});
		},
          async getAllTeams() {
            this.teamObject = []
            let users:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                users = res.data;
                this.teamsData = res.data;
            });
            for (var i = 0; i < users.length; i++) {
                this.teamObject.push({ label: users[i].displayName, value: users[i]._id });
            }
        },
		 async getallEntities() {
            this.locationObject = []
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
                this.allEntities = res.data
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityDisplayName, value: result[i]._id,entityType:result[i].entityType});
            }
        },
        filterOpen() {
			this.showFilters = !this.showFilters;
			emitter.emit('visible', this.showFilters);
            this.filterDummy = {}
		},
        goToControlTaskEdit(row:any){            
            emitter.emit('openDetailsModal', {
				view: 'crTask',
				title: row.taskId || row.controlTitle || 'Task',
				params: { taskId: row._id, complianceId: row.complianceId },
			});
        },
        
	},
});
</script>
